import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

const ACCESORIES_KEY = KEYS.ticket.taskForce.getMeSuppliesByID();

type Props = {
  ticketId?: number;
  btnOnClick?: boolean;
};

function useGetMeSupplies({ ticketId, btnOnClick }: Props) {
  const { showApiError } = useGlobalContext();
  const { inventory: inventoryApi } = useApiContext();
  const { t } = useTranslation('global');
  const supplies = useQuery(
    [ACCESORIES_KEY, ticketId],
    () =>
      inventoryApi.taskForce.getMeSuppliesByID({
        ticketId
      }),
    {
      select: (data) => data?.data?.data,
      enabled: !!ticketId && btnOnClick,
      onError: (error) => showApiError(error, t('errorMessages.supplies')),
      refetchOnWindowFocus: false
    }
  );

  return {
    supplies
  };
}

export default useGetMeSupplies;
